import { defineMessages } from 'react-intl';

export default defineMessages({
  ledgerHelpCaption: 'Connect your Ledger & Enter PIN',
  ledgerHelpDescription:
    'Open the Ethereum application and make sure Contract Data and Browser Support are enabled',
});
